import { render } from "./formControl.vue?vue&type=template&id=26906cca&scoped=true"
import script from "./formControl.vue?vue&type=script&lang=js"
export * from "./formControl.vue?vue&type=script&lang=js"

import "./formControl.vue?vue&type=style&index=0&id=26906cca&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26906cca"]])

export default __exports__